import React, { useContext, useEffect } from 'react'
import { Spinner } from 'reactstrap';
import AccessContext from '../../context/AccessContext/AccessContext';
import { useParams } from 'react-router-dom';

const CheckingAccess = () => {
    const { accessState, checkAccess } = useContext(AccessContext);
    const { isFetching } = accessState;

    const { identificator } = useParams();

    useEffect(() => {
        checkAccess(identificator)
        // eslint-disable-next-line
    }, [identificator])

    if (isFetching) {
        return (
            <div className="d-flex justify-content-center">
                <Spinner />
            </div>
        );
    }
}

export default CheckingAccess